import {
  $walletBalance,
  startBalancePolling,
  stopBalancePolling,
  updateWalletBalanceFx,
} from "state/balance";

import { useEffect } from "react";
import { useStore } from "effector-react";

export const useBalance = () => {
  const sol = useStore($walletBalance);

  useEffect(() => {
    startBalancePolling();

    return () => {
      stopBalancePolling();
    };
  }, []);

  const balance = sol === null ? null : { sol };
  return { balance, fetch: updateWalletBalanceFx };
};
